<div class="text-size ">
  <div class="border p-2 text-center rounded-1 m-1 mt-4">
    @if (isControlPointAssigned() ) {
      <div>
        <div class="row mr-0">
          <div class="col-12 d-flex align-items-center">
            <strong> {{assignedControlPoint?.name}}</strong><br>
          </div>
        </div>
        <div class="row mr-0">
          <div class="col-12 d-flex align-items-center">
            <img src="assets/icon/control-point-black.svg"  alt="control-point icon"/>
            <span class="ml-2"> {{'RECORD.MEASUREMENT_POINT' | translate}}</span><br>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-6">
            <button type="button" class="secondary-button"
              (click)="modifyAssignedCp()">
              <span
              >{{'BUTTONS.MODIFY' |
            translate}}</span>
          </button>
        </div>
        <div class="col-6">
          <button type="button" class="tertiary-button" (click)="unassignRecord('controlPoint')">
            <span >{{'BUTTONS.UNASSIGN' | translate}}</span>
          </button>
        </div>
      </div>
    </div>
  }
  @if (!isControlPointAssigned()) {
    <div>
      <div class="p-2">
        <strong>
          {{ (vibrationRecord().controlPointId === 0 || vibrationRecord().controlPointId === null)
          ? ('RECORD.NO_MEASUREMENT_POINT' | translate)
          : ('RECORD.MODIFY_MEASUREMENT_POINT' | translate) }}
        </strong>
      </div>
      <app-autocomplete [options]="optionsControlPoints" [placeholder]="placeholderCp"
        (optionSelected)="onOptionCpSelected($event)">
      </app-autocomplete>
      @if (vibrationRecord().controlPointId !== 0 && vibrationRecord().controlPointId !== null) {
        <button
          class="tertiary-button" (click)="cancel('controlPoint')">
          <span class="font-weight-600"> {{'BUTTONS.CANCEL' | translate}} </span>
        </button>
      }
      <button class="btn btn-primary action-button" (click)="assignRecord('controlPoint')">
        <span class="font-weight-600"> {{'BUTTONS.ASSIGN' | translate}} </span>
      </button>
    </div>
  }


</div>

<div class="border p-2 text-center m-1 rounded-1 mt-4">

  <div class="row mr-0">
    <div class="col-12 d-flex align-items-center">
      <strong> {{deviceRef()}}</strong><br>
    </div>
  </div>

  <div class="row mr-0">
    <div class="col-12 d-flex align-items-center">
      <img src="assets/icon/device.svg" alt="device icon"/><br>
      <span class="ms-2 "> {{'RECORD.LABEL_DEVICE' | translate}}</span><br>
    </div>
  </div>
</div>
</div>